import {postRequest, deleteRequest} from "../api";

export const createJudgement = data => {
  return postRequest("/judgement", data, {serverOptions: {privateURL: true}});
};

export const deleteJudgement = judgementId => {
  return deleteRequest(`/judgement/${encodeURIComponent(judgementId)}`, null, {
    serverOptions: {privateURL: true}
  })
}
